export enum CustomerAddressTypeKey {
   Headquarters = 'headquarters',
   Branch = 'branch',
}

export interface CustomerAddressType {
   id: number;
   key: CustomerAddressTypeKey;
   name: Record<string, string> | string;
}
